module.exports = __webpack_public_path__ + "fonts/element-icons.27c72091.ttf";